<template>
  <span class="tag project-tag is-uppercase has-text-weight-medium" :class="[color || defaultColor]">
    <b-icon :pack="icon.pack" :icon="icon.name" size="is-small" class="mr-4px" />
    {{ label }}
  </span>
</template>

<script>
import EnumHelper from '@/helpers/enums'
import { PROJECT_STATUS_ACTIVE, PROJECT_STATUS_INACTIVE, PROJECT_STATUS_FINISH } from '@/consts/enums'

export default {
  props: {
    status: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: false
    }
  },
  computed: {
    label() {
      return EnumHelper.formatProjectStatus(this.status)
    },
    defaultColor() {
      switch (this.status) {
        case PROJECT_STATUS_ACTIVE:
          return 'project-tag--blue'
        case PROJECT_STATUS_INACTIVE:
          return 'project-tag--outlined'
        case PROJECT_STATUS_FINISH:
          return 'project-tag--green'
        default:
          return ''
      }
    },
    icon() {
      switch (this.status) {
        case PROJECT_STATUS_ACTIVE:
          return { name: 'circle', pack: 'far' }
        case PROJECT_STATUS_INACTIVE:
          return { name: 'ellipsis-h', pack: 'fas' }
        case PROJECT_STATUS_FINISH:
          return { name: 'check', pack: 'fas' }
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.project-tag {
  letter-spacing: 0.05em;

  &--blue {
    background-color: $pale-blue;
    color: $blue;
  }

  &--green {
    background-color: $pale-green;
    color: $green;
  }

  &--outlined {
    background-color: $white;
    color: $grey-light;
    border: 1px solid $grey-light;
  }
}
</style>